import { useTranslation } from 'react-i18next';

import { Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

import { useEnumApi } from 'contexts/EnumApiContext';
import { deleteMaintenanceTasks } from 'components/axios/maintenanceAxios';
import FileDownloadIcon from 'components/FileDownloadIcon';
import MainCard from 'components/MainCard';
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import MaintenanceTaskModal from 'components/modal/MaintenanceTaskModal';
import { fromServerFormat } from 'components/date_picker/dateUtils';
import { writeAuditLog } from 'components/axios/auditLogger';
import MaintenanceTaskConfirmModal from 'components/modal/MaintenanceTaskConfirmModal';

const MaintenanceTaskInfoCard = ({maintenanceTask, onRefresh, linkTarget=""}) => {
    const { getEnumValueByEnumNameAndCode, role } = useEnumApi();
    const { t } = useTranslation();

    // modal 관련
    const { openModal } = useModals();
    const handleAlertClick = (alertMessage) => {
      openModal(modals.alertModal, {
          onClose : () => {
              console.log('');
          },
          message: alertMessage,
      });
    };

    const handleDeleteBtnClick = (param) => {
      console.log(param)
      
      openModal(modals.confirmModal, {
        onSubmit : (value) => {
          deleteMaintenanceTasks(param)
          .then(async(res) => {
            console.log(res)
            await writeAuditLog({
                actionType: "DELETE",
                targetType: "ALERT",
                targetId: param,
                // targetName: equipmentAlert?.id,
                targetName: maintenanceTask?.equipment?.equipmentNo,

                apiUrl : `/api/maintenanceTasks/${param}`,
                requestMethod : 'DELETE',
                // summary: t('message.common.log.memo.alert.maintenance.delete'),
                summary: 'message.common.log.memo.alert.maintenance.delete',
                payload : null
            });

            document.location.href = '..'+window.location.search;
          }).catch((err)=>{
            console.log(err);
            handleAlertClick(err.response?.data?.message || err.message);
          });
        },
        onClose : () => {
          console.log('close');
        },
        message: t('message.common.alert.maintenance.delete.question'),
      });
    }

    if (maintenanceTask) {
      return (
        <>
        <div className='alert_phrase'>
          <MainCard className="center_table" content={false}>
            <div className="stpes" style={{display:"flex", alignItems:"center", flexWrap:"wrap"}}>
              <Chip label={t('message.common.title.maintenance')} color="success" />
            </div>

            <TableContainer>
              <Table sx={{ minWidth: 500 }} aria-label="simple table" className="same_width" style={{borderCollapse:"unset", borderSpacing:"revert"}}>
                <TableBody>
                  <TableRow>
                    <TableCell className="th" align="center">{t('message.common.subtitle.work.start.date')}</TableCell>
                    <TableCell align="center">{maintenanceTask.workingBgnAt && fromServerFormat(maintenanceTask.workingBgnAt, {format:t('message.common.text.date.format.date')})}</TableCell>
                    <TableCell className="th" align="center">{t('message.common.subtitle.work.start.time')}</TableCell>
                    <TableCell align="center">{maintenanceTask.workingBgnAt && fromServerFormat(maintenanceTask.workingBgnAt, {format:"HH:mm:ss"})}</TableCell>
                    <TableCell className="th" align="center">{t('message.common.subtitle.breakdown.maintenance.cause')}</TableCell>
                    <TableCell align="center">{maintenanceTask.trouble && getEnumValueByEnumNameAndCode("EquipmentTrouble", maintenanceTask.trouble) && getEnumValueByEnumNameAndCode("EquipmentTrouble", maintenanceTask.trouble)?.[0]?.title}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="th" align="center">{t('message.common.subtitle.work.end.date')}</TableCell>
                    <TableCell align="center">{maintenanceTask.workingEndAt && fromServerFormat(maintenanceTask.workingEndAt, {format:t('message.common.text.date.format.date')})}</TableCell>
                    <TableCell className="th" align="center">{t('message.common.subtitle.work.end.time')}</TableCell>
                    <TableCell align="center">{maintenanceTask.workingEndAt && fromServerFormat(maintenanceTask.workingEndAt, {format:"HH:mm:ss"})}</TableCell>
                    <TableCell className="th" align="center">{t('message.common.subtitle.actionType')}</TableCell>
                    <TableCell align="center">{maintenanceTask.type && getEnumValueByEnumNameAndCode("MaintenanceType", maintenanceTask.type)?.[0]?.title}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="th" align="center">{t('message.common.subtitle.worker')}</TableCell>
                    <TableCell colSpan={3} align="center">{maintenanceTask.worker}</TableCell>
                    <TableCell className="th" align="center">{t('message.common.subtitle.work.status')}</TableCell>
                    <TableCell align="center">
                      <div className={(maintenanceTask.status === 'O1_R' ? "condition1":(maintenanceTask.status === 'O2_P' ? "condition2":
                          (maintenanceTask.status === 'O3_C' ? "condition5":"condition6")))}>
                          {(maintenanceTask.status && getEnumValueByEnumNameAndCode("MaintenanceStatus", maintenanceTask.status)?.[0]?.title)}
                      </div>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="th" align="center">{t('message.common.subtitle.work.detail')}</TableCell>
                    <TableCell className="pl" colSpan={5} style={{textAlign:"left"}}>
                      {maintenanceTask.remark}
                    </TableCell>
                  </TableRow>
                  {maintenanceTask.equipmentParts &&
                  <TableRow>
                    <TableCell className="th" align="center">{t('message.common.subtitle.input.material')}</TableCell>
                    <TableCell className="pl" colSpan={5} style={{textAlign:"left",padding:"0"}}>
                      <Table sx={{ minWidth: 800 }} aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell className="th" align="center">{t('message.common.subtitle.material')}</TableCell>
                            <TableCell className="th" align="center">{t('message.common.subtitle.input.part')}</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {maintenanceTask.equipmentParts.map(function(item, i) {
                            return (
                          <TableRow key={i}>
                            <TableCell align="center">{item.masterEquipmentPart.name}</TableCell>
                            <TableCell align="center">{item.subPart}</TableCell>
                          </TableRow>
                            )
                          })}
                        </TableBody>
                      </Table>
                    </TableCell>
                  </TableRow>
                  }
                  <TableRow>
                    <TableCell className="th" align="center">{t('message.common.subtitle.status.report.file')}</TableCell>
                    <TableCell align="center" colSpan={5}>
                      {maintenanceTask.statusReport && maintenanceTask.statusReport.reportFiles && maintenanceTask.statusReport.reportFiles.map(function(file, idx) {
                          return (
                            <div key={idx}><FileDownloadIcon file={file} viewFileName={true}/>{(maintenanceTask.statusReport.reportFiles-1)>idx && <br/>}</div>
                          )
                        })
                      }
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </MainCard>
        </div>

        <div className="btn_right">
          <div>
            <MaintenanceTaskModal id={maintenanceTask.id} onRefresh={onRefresh} type="modify" />
            {/* <MaintenanceTaskConfirmModal maintenanceTask={maintenanceTask} onRefresh={onRefresh} /> */}
            {/* {(maintenanceTask && maintenanceTask.status === 'O1_R') &&
            <PermissionButton
                permission={PERMISSIONS.MAINTENANCE_TASK_DELETE}
                variant="contained" color="error" style={{marginLeft:"7px"}} onClick={()=>{handleDeleteBtnClick(maintenanceTask.id)}}
            >
                {t('message.common.btn.maintenanceTask.delete')}
            </PermissionButton>
            } */}
          </div>
        </div>
        </>
      )
    }
}

export default MaintenanceTaskInfoCard;